export type Delta = { pct: number } | { points: number } | "no-comparison"

/**
 * A figure against the previous window's. `null` (nothing at all happened
 * then) and growth from zero have no honest percentage: "no comparison",
 * never +∞ %. Rates compare in points.
 */
export function delta(current: number, previous: number | null, unit: "pct" | "points" = "pct"): Delta {
  if (previous === null) return "no-comparison"
  if (unit === "points") return { points: Math.round((current - previous) * 1000) / 10 }
  if (previous === 0) return current === 0 ? { pct: 0 } : "no-comparison"
  return { pct: Math.round(((current - previous) / previous) * 1000) / 10 }
}
